import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages } from 'react-intl';

import Form from 'components/Form';
import fieldTypes from 'components/Form/fieldTypes';
import FormHeader from 'components/Form/FormHeader';
import SettingsPage from 'components/Pages/User/SettingsPage';
import { selectUser } from 'selectors/user';
import { setUser } from 'actions/user';
import settingsMessages from 'components/settingsMessages';
import updateDetails from '../updateDetails';

const messages = defineMessages({
  editPhoneNumberTitle: {
    defaultMessage: 'Edit Phone Number',
  },
  addPhoneNumberTitle: {
    defaultMessage: 'Add Phone Number',
  },
  telephoneUpdated: {
    defaultMessage: 'Telephone number updated successfully.',
  },
  errorUpdating: {
    defaultMessage: 'Could not update phone number, please try again later.',
  },
});

const formFields = [
  {
    ...fieldTypes.telephone,
    required: true,
  },
  {
    ...fieldTypes.password,
    helpMessage: <FormattedMessage {...settingsMessages.passwordMessage} />,
  },
];

class EditPhoneNumber extends React.Component {
  static propTypes = {
    setUser: PropTypes.func,
    user: PropTypes.instanceOf(Map),
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }

  onSubmit = (values, callback) => {
    const email = this.props.user.get('email');
    const newDetails = {
      telephone: values.telephone,
    };

    updateDetails({ email, password: values.password, newDetails })
      .then(({ user }) => {
        this.props.setUser(user);
        callback({ success: true });
      })
      .catch(error => {
        const message = error.message === 'forbidden' ? settingsMessages.forbidden : messages.errorUpdating;
        this.setState({ error: message });
        callback({ error: true });
      });
  };

  render() {
    const defaultTitle = this.props.user.get('telephone') ? (
      <FormattedMessage {...messages.editPhoneNumberTitle} />
    ) : (
      <FormattedMessage {...messages.addPhoneNumberTitle} />
    );

    return (
      <SettingsPage>
        <FormHeader title={defaultTitle} requiredFields={true} />
        <Form
          fields={formFields}
          onSubmit={this.onSubmit}
          submitButtonLabel={<FormattedMessage {...settingsMessages.saveChanges} />}
          errorHeader={<FormattedMessage {...settingsMessages.updateError} />}
          errorMessage={this.state.error ? <FormattedMessage {...this.state.error} /> : ''}
          successHeader={<FormattedMessage {...settingsMessages.success} />}
          successMessage={<FormattedMessage {...messages.telephoneUpdated} />}
        />
      </SettingsPage>
    );
  }
}

const mapStateToProps = state => ({
  user: selectUser(state),
});

export default connect(mapStateToProps, { setUser })(EditPhoneNumber);
